import { Flex } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import React from "react";
import {
  FormType,
  getBirthdateFilterFormValue,
} from "src/scenes/orgAdmin/formTemplates/ContentTab/V1/formik";
import * as Draft from "src/scenes/orgAdmin/formTemplates/types/draft";
import * as AF from "src/types/formTemplate";
import * as GQL from "src/types/graphql";
import * as RD from "src/types/remoteData";
import { QuestionVisibility } from "../../QuestionVisibility";
import { ConfigureDateOfBirth } from "../QuestionConfiguration/ConfigureDateOfBirth";
import { ConfigureQuestion } from "../QuestionConfiguration/ConfigureQuestion";
import {
  ConfigureQuestionMenu,
  ConfigureQuestionMenuTabs,
} from "../QuestionConfiguration/ConfigureQuestionMenu";
import { SchoolItem } from "../types";
import { QuestionLink } from "./QuestionLink";

export type GradeQuestionFormProps = {
  questionId: uuid;
  gradesConfig: GQL.GetGradesConfigByOrganization_grade_config[];
  otherQuestions: readonly Draft.Question[];
  schools: RD.RemoteData<unknown, SchoolItem[]>;
  sectionType: AF.SectionType;
  verificationOptions: AF.FormVerification<AF.WithId>[];
};
export function GradeQuestionForm({
  questionId,
  gradesConfig,
  otherQuestions,
  schools,
  sectionType,
  verificationOptions,
}: GradeQuestionFormProps) {
  const [configureQuestionTab, setConfigureQuestionTab] =
    React.useState<ConfigureQuestionMenuTabs>(
      ConfigureQuestionMenuTabs.ConfigureQuestion
    );

  const formik = useFormikContext<FormType>();

  const handleConfigureMenuChange = (newTab: ConfigureQuestionMenuTabs) => {
    setConfigureQuestionTab(newTab);
  };

  const questionBirthdateFilter = getBirthdateFilterFormValue(
    questionId,
    formik.values
  );

  return (
    <>
      <Flex direction="row" gap="4">
        <ConfigureQuestionMenu
          activeTab={configureQuestionTab}
          onMenuChange={handleConfigureMenuChange}
          items={[
            { type: "Separator", label: "Limit available options" },
            {
              type: ConfigureQuestionMenuTabs.DateOfBirth,
              label: "Date of birth",
              status: questionBirthdateFilter.length > 0 ? "on" : "off",
            },
          ]}
        />
        {configureQuestionTab ===
          ConfigureQuestionMenuTabs.ConfigureQuestion && (
          <ConfigureQuestion
            questionId={questionId}
            questionType={AF.GradesType}
            verificationOptions={verificationOptions}
          />
        )}
        {configureQuestionTab === ConfigureQuestionMenuTabs.DateOfBirth && (
          <ConfigureDateOfBirth
            questionId={questionId}
            gradesConfig={gradesConfig}
          />
        )}
      </Flex>
      {configureQuestionTab === ConfigureQuestionMenuTabs.ConfigureQuestion && (
        <Flex direction="column" flexGrow="1" gap="3">
          <QuestionLink questionId={questionId} />
          <QuestionVisibility
            sectionType={sectionType}
            questionId={questionId}
            otherQuestions={otherQuestions}
            schools={schools}
          />
        </Flex>
      )}
    </>
  );
}
